<template>
  <div class="row text-center mt-0 mb-0">
    <div class="col-md-12">
      <canvas
          id="signature-canvas"
          width="350"
          height="200"
          style="border: 1px solid rgb(208, 208, 208);"
          ref="canvasRef"></canvas>
      <input v-model="formData.digitalSignature" type="hidden"/>
    </div>
    <div class="col-md-12">
      <div class="d-flex flex-row justify-content-center align-items-center">
        <div style="width: 350px; margin: 0 auto">
          <SelectVue
              v-model="formData.note"
              :options="noteDropdown"
              :is-clear="true"
              placeholder="Bemerkung"/>
        </div>
      </div>
    </div>
  </div>

  <div class="digital-signature-image" v-if="existingDigitalSignature">
    <div class="d-flex flex-row justify-content-center align-items-center">
      <div style="width: 350px; margin-bottom: 20px;">
        <span>Aktuelle Signatur</span>
        <img
            class="img-fluid"
            :src="existingDigitalSignature"
            alt="Signature"
            style="width: 350px; height: 120px; object-fit: contain; border: 1px solid rgb(208, 208, 208);"/>
      </div>
    </div>
  </div>

  <div class="d-flex flex-row justify-content-center align-items-center modal-buttons">
    <div class="modal_buttons_container">
      <button class="btn btn-primary mr-3" @click="saveSignature"> {{ $t('general.button.save') }}</button>
      <button class="btn btn-danger" @click="clearSignature"> {{ $t('general.button.delete') }}</button>
    </div>
  </div>
</template>

<script setup>
import portalCaseManagementCoachingService from '@/api/Portal/CaseManagementCoaching';
import SelectVue from '@/components/SelectVue.vue';
import { ErrorToast, SuccessToast } from '@/components/VueToast';
import { digitalSignatureNoteDropdown } from '@/shared/dropdowns';
import SignaturePad from 'signature_pad';
import { defineEmits, defineProps, onMounted, ref, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

const emit                     = defineEmits([ 'update:modelValue', 'update:submitForm' ]);
const { t }                    = useI18n();
const noteDropdown             = ref([]);
const canvasRef                = ref(null);
const existingDigitalSignature = ref('');
const isLoaded                 = ref(false);
let signaturePad               = null;

const props = defineProps({
  coachingId: {
    type: [ Number, String ],
    required: true,
  },
  meetingId: {
    type: [ Number, String ],
    required: true,
  },
  meetingType: {
    type: String,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const meetingType = toRefs(props)[ 'meetingType' ];
const meetingId   = toRefs(props)[ 'meetingId' ];
const coachingId  = toRefs(props)[ 'coachingId' ];

const formData = ref({
  digitalSignature: '',
  coachingId: +coachingId.value,
  meetingId: +meetingId.value,
  note: '',
});

async function saveSignature() {
  if (signaturePad && !signaturePad.isEmpty()) {
    formData.value.digitalSignature = signaturePad.toDataURL('image/png');
  } else {
    formData.value.digitalSignature = ''; // Clear if empty
  }

  try {
    await portalCaseManagementCoachingService.saveDigitalSignature(formData.value);

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);

    if (signaturePad && !signaturePad.isEmpty()) {
      emit('update:missingDigitalSignature', false);
    }

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

const clearSignature = () => {
  if (signaturePad) {
    signaturePad.clear();
    formData.value.digitalSignature = '';
  }
};

async function getProtocolData() {
  try {
    const { data }                 = await portalCaseManagementCoachingService.getProtocol(meetingId.value);
    existingDigitalSignature.value = data.data.digitalSignatureBase64;
    formData.value.note            = data.data.digitalSignatureNote;
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getFirstInterviewData() {
  try {
    const { data }                 = await portalCaseManagementCoachingService.getFirstInterviewData(coachingId.value);
    existingDigitalSignature.value = data.data.firstInterview.digitalSignatureBase64;
    formData.value.note            = data.data.firstInterview.digitalSignatureNote;
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  noteDropdown.value = digitalSignatureNoteDropdown();

  if (canvasRef.value) {
    signaturePad = new SignaturePad(canvasRef.value, {
      backgroundColor: '#fff',
      penColor: 'rgb(0, 0, 0)',
    });
  }

  if (meetingType.value === 'firstInterview') {
    await getFirstInterviewData();
  } else {
    await getProtocolData();
  }

  isLoaded.value = true;
});
</script>

<style scoped>
canvas {
  cursor: crosshair;
}

.modal_buttons_container {
  display: flex;
  gap: 165px; /* Adjust the gap as needed */
}
</style>